import actions from "./actions";
import mutations from "./mutations";
import * as getters from "./getters";

export const defaultAuthState = () => {
  return {
    username: null,
    authToken: null,
    refreshToken: null,
    authTokenExpiresIn: null,
    userInfo: {},
    kids: []
  };
};

// initial state
const state = defaultAuthState();

// mutations

export default {
  state,
  mutations,
  actions,
  getters
};
